import React from 'react';
import { css } from 'aphrodite';
import styles from './home-location-marker-styles';
import {FaHome} from 'react-icons/fa';

const LiveLocationMarkerView = (props) => (
  <div className={css(styles.root)} onMouseEnter={props.mouseEnter} onMouseLeave={props.mouseLeave}>

    {!props.expanded && <div className={css(styles.homeIconContainer)} onClick={() => props.setCurrentDriverCardOnMap(props.driver, props.lat, props.lng)} style={{cursor: props.hovered? 'pointer': 'default'}}>
      <FaHome className={css(styles.homeIcon)} />
    </div>}

  </div>
);

export default LiveLocationMarkerView;



// WEBPACK FOOTER //
// ./src/components/map-markers/home-location-marker-view.js